import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ConvertersIndex from "@/pages/ConvertersIndex";
import ConverterCategory from "@/pages/ConverterCategory";
import ConverterPage from "@/pages/ConverterPage";
import { CalculatorsIndex, TextToolsIndex } from "@/pages/CategoryIndexes";
import CalculatorPage from "@/pages/CalculatorPage";
import TextToolPage from "@/pages/TextToolPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/converters" element={<ConvertersIndex />} />
            <Route path="/converters/:categoryId" element={<ConverterCategory />} />
            <Route path="/convert/:categoryId/:from/:to" element={<ConverterPage />} />
            <Route path="/calculators" element={<CalculatorsIndex />} />
            <Route path="/calculators/:slug" element={<CalculatorPage />} />
            <Route path="/text-tools" element={<TextToolsIndex />} />
            <Route path="/text-tools/:slug" element={<TextToolPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
